<template>
    <div class="portfolio-piece">
        <h2>{{title}}</h2>
        <youtube v-if="videoid" :video-id="videoid" class="media"/>
        <p v-if="image" class="media">
            <img :src="'images/' + image">
        </p>
        <p>{{description}}</p>
        <div class="buttons">
            <a class="button" :href="source" target="_blank">Source</a>
            <span class="button">Demo: <a :href="demo.link" target="_blank">{{demo.content}}</a></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        description: String,
        source: String,
        demo: Object,
        image: String,
        videoid: String
    }
}
</script>

<style lang="scss">
.portfolio-piece {
    color: #fff;
    background: #424242;
    width: 70vw;
    margin: 40px;
    padding: 40px;

    border-radius: 2px;
    display: inline-block;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

    h2 {
        margin: 0px;
    }

    .media {
        display: block;
        text-align: center;
        height: 390px;
        margin: 10px;
        img {
            display: inline-block;
            height: 100%;
        }
    }

    .buttons {
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .button {
            margin-right: 10px;
            text-decoration: none;
            padding: 10px;
            color: #fff;
            background: rgba(255, 255, 255, 0.1);
        }
    }
}
</style>
